import { motion } from "framer-motion";
import { MANIFESTO, IMAGES } from "@/data/content";

function Chapter({ item, index }) {
  const reversed = index % 2 === 1;
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`manifesto-chapter-${item.n}`}
      className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-center ${reversed ? "lg:[direction:rtl]" : ""}`}
    >
      <div className="lg:col-span-7 [direction:ltr]">
        <div className="flex items-baseline gap-6">
          <span className="font-display font-900 text-6xl sm:text-7xl lg:text-8xl text-transparent [-webkit-text-stroke:1px_rgba(34,211,238,0.5)]">
            {item.n}
          </span>
          <span className="h-px flex-1 bg-white/10 mb-4" />
        </div>
        <h3 className="mt-6 font-display font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-[1.05]">
          {item.head}
        </h3>
        <p className="mt-6 max-w-lg text-base text-slate-400 leading-relaxed">{item.body}</p>
      </div>
      <div className="lg:col-span-5 [direction:ltr]">
        <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
          <img
            src={[IMAGES.mesh, IMAGES.padlock, IMAGES.network][index]}
            alt={item.head}
            className="w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#05050A] to-transparent" />
          <div className="absolute inset-0 ring-1 ring-inset ring-[#22D3EE]/20" />
        </div>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 lg:py-40 bg-[#05050A]" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-20">
          <span className="text-xs uppercase tracking-[0.3em] text-[#22D3EE]">The manifesto</span>
          <h2 className="mt-5 font-display font-900 text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white leading-none">
            Why the sphere exists
          </h2>
        </div>
        <div className="space-y-24 lg:space-y-32">
          {MANIFESTO.map((item, i) => (
            <Chapter key={item.n} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
